module.exports = __webpack_public_path__ + "img/hero-1-bg.440c6d74.png";